var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring-root"},[_vm._t("title"),_c('div',{ref:"ring_id",attrs:{"id":_vm.id}},[(_vm.showMiddleSlot)?_c('div',{staticClass:"middleSlot"},[_vm._t("default")],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }